export default __webpack_public_path__ + "static/media/retextured-coexistence.4516afb6.png";